// Short-term-rental (holiday-home) presets + defaults. The live values come from
// the backend `/analysis/str-config` endpoint (editable JSON, no code change);
// these constants are the fallback if that fetch fails.

export const STR_CONFIG_FALLBACK = {
  furnishing_presets: {
    furnished: { Studio: 7000, '1BR': 12000, '2BR': 15000 },
    unfurnished: { Studio: 14000, '1BR': 19000, '2BR': 23000 },
    extra_bedroom_increment: 5000,
  },
  str_defaults: {
    occupancy: 75, mgmtPct: 20, dewaMonthly: 800, gasMonthly: 100,
    internetMonthly: 300, chillerMonthly: 500, dtcmLicenseYearly: 1500,
    tourismPerNight: 15, furnitureRefreshPct: 10, miscYearly: 0,
  },
};

// Rough bedroom count for extrapolating presets on non-tabled unit types.
export function bedroomsForType(unitType) {
  const t = (unitType || '').toLowerCase();
  if (t.includes('studio')) return 0;
  const m = t.match(/(\d+)\s*br/);
  if (m) return Number(m[1]);
  if (t.includes('penthouse') || t.includes('townhouse')) return 3;
  if (t.includes('villa')) return 4;
  return 2; // office / unknown -> treat as 2BR baseline
}

// Furnishing preset for a unit type + furnished status, extrapolating for 3BR+.
export function furnishingPreset(unitType, furnished, config = STR_CONFIG_FALLBACK) {
  const presets = config.furnishing_presets || STR_CONFIG_FALLBACK.furnishing_presets;
  const table = furnished ? presets.furnished : presets.unfurnished;
  const inc = presets.extra_bedroom_increment ?? 5000;
  const bedrooms = bedroomsForType(unitType);
  const key = bedrooms <= 0 ? 'Studio' : bedrooms === 1 ? '1BR' : '2BR';
  const base = Number(table[key]) || 0;
  const extra = bedrooms > 2 ? (bedrooms - 2) * inc : 0;
  return base + extra;
}

// Resolve STR expense params: defaults <- config <- explicit overrides.
export function strDefaults(config = STR_CONFIG_FALLBACK) {
  return { ...STR_CONFIG_FALLBACK.str_defaults, ...(config.str_defaults || {}) };
}

// Human labels for the expense line items (keys must match the engine).
export const STR_EXPENSE_LABELS = {
  management: 'Management company',
  dewa: 'DEWA (water & electricity)',
  gas: 'Gas',
  internet: 'Internet',
  chiller: 'Chiller / cooling',
  dtcm: 'DTCM holiday-home license',
  tourism: 'Tourism dirham',
  sc: 'Service charge',
  furniture: 'Furniture refresh reserve',
  misc: 'Other / miscellaneous',
};
